import img1 from "../assets/intro_screens/Intro_img_1.jpg";
import img2 from "../assets/intro_screens/Intro_img_2.jpg";
import img3 from "../assets/intro_screens/Intro_img_3.jpg";
import img4 from "../assets/intro_screens/Intro_img_4.jpg";
import img5 from "../assets/intro_screens/Intro_img_5.jpg";

export const T3_LOGO = "https://s3.ap-southeast-1.amazonaws.com/visaero.assets/logo/t3_visas_logo.png";

export const SLIDES = [
  {
    label: "e-Visa VisaLancer",
    background: img1,
  },
//   {
//     label: "e-Visa VisaLancer",
//     background: img2,
//   },
//   {
//     label: "e-Visa VisaLancer",
//     background: img3,
//   },
//   {
//     label: "e-Visa VisaLancer",
//     background: img4,
//   },
//   {
//     label: "e-Visa VisaLancer",
//     background: img5,
//   },
];
